import { useBuilderStore } from '../store/builderStore';

export const useBuilderState = () => {
  return useBuilderStore();
};
